<template>
  <div
    class="flex items-start justify-between gap-3 border-b bg-white px-4 py-3 md:px-6 md:py-4"
  >
    <div class="min-w-0">
      <p class="text-[11px] uppercase tracking-wide text-gray-500">
        {{ $t("ticketPurchase.header") }}
      </p>
      <p class="break-words text-base font-bold text-[#2e234b] md:text-lg">
        {{ eventName }}
      </p>
    </div>
    <button
      class="text-xl leading-none text-gray-500 hover:text-pink-500"
      aria-label="Close ticket modal"
      @click="$emit('close')"
    >
      &times;
    </button>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  eventName: string;
}>();

defineEmits<{
  (e: "close"): void;
}>();
</script>
